import { render, staticRenderFns } from "./PQuotaCard.vue?vue&type=template&id=2700f834&scoped=true"
import script from "./PQuotaCard.vue?vue&type=script&lang=ts"
export * from "./PQuotaCard.vue?vue&type=script&lang=ts"
import style0 from "./PQuotaCard.vue?vue&type=style&index=0&id=2700f834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700f834",
  null
  
)

export default component.exports